import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserCreators } from "redux/modules/user";
import { useNavigate } from "react-router-dom";


const Logout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isUnlinked = useSelector((state) => state.user.isUnlinked)

    const logout = () => {
        // dispatch(UserCreators.kakaoLogout())    
        dispatch(UserCreators.kakaoUnlink())
    }
    
    if(isUnlinked === true) {
        navigate('/')
    }

    return (
        <>
            <button onClick={logout}>로그아웃</button>
        </>
    )
}

export default Logout;